var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"end-screen"}},[_c('h1',[_vm._v("End Screen ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }